import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22.517 3.427a1.214 1.214 0 1 0 .001-2.429 1.214 1.214 0 0 0-.001 2.43Z",
  stroke: "currentColor",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M28 10c0-2.212 1.352-3.99 3-3.99-1.667 0-3-1.798-3-4.01 0 2.212-1.352 3.99-3 3.99 1.667 0 3 1.798 3 4.01ZM7 6s1.698 6.492 5.661 9.558c4 3.09 7.7 7.737 7.347 11.169-.239 2.276 9.36-10.166 2.541-18.47C16.26.617 7 6 7 6Z",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7 6s-4.729 2.53-3.718 9.748c.517 3.734 2.785 7.218 2.082 9.867C4.736 27.942 2 29.385 2 29.385s4.202 3.46 9.205.25c2.625-1.694 3.611-4.748 2.046-6.263-1.097-1.062-3.118.262-4.054-.943-.505-.656-.456-1.396-.74-2.23-.148-.43-.308-1.576-.714-1.803-.838-.465-1.233-.787-1.233-1.097 0-.585.986-1.885 1.072-2.768.111-1.17-1.011-2.92.418-5.031",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }